<div class="bg-img-container">
  <div class="container">
    <div class="form">
      <h2 id="heading">Report Time</h2>
      <form
        name="form"
        (ngSubmit)="f.form.valid && ok()"
        #f="ngForm"
        novalidate
      >
        <div>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Select Date"
              [formControl]="date"
              [max]="max"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #picker
              startView="multi-year"
              disabled="false"
              (yearSelected)="chosenYearHandler($event)"
              (monthSelected)="chosenMonthHandler($event, picker)"
              panelClass="example-month-picker"
            >
            </mat-datepicker>
            <mat-error *ngIf="date.invalid">Invalid Date</mat-error>
          </mat-form-field>
        </div>

        <div>
          <button id="generate-monthly-report" mat-raised-button class="login">
            Ok
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
